import { CommonDecoratedTag } from '@atlassian/jira-polaris-lib-decoration/src/ui/decoration/common/index.tsx';

export const DecoratedTagComponent = CommonDecoratedTag;
